import React from 'react';
import TemplateForm from '../../components/TemplateForm/TemplateForm';
import TitleFrame from '../../components/TitleFrame';
import useBankInfo from '../../hooks/useBankInfo';
import { useOpts } from '../../../context';
import { checkHackyWorkspace } from '../../../utils/hacky-workspace-customizations';
var CITIZENS_ROUTING_NOS = [
    ['211170114', 'Connecticut'],
    ['031101143', 'Delaware'],
    ['211070175', 'Massachusetts'],
    ['241070417', 'Michigan'],
    ['011401533', 'New Hampshire'],
    ['036076150', 'New Jersey'],
    ['021313103', 'New York'],
    ['241070417', 'Ohio'],
    ['036076150', 'Pennsylvania'],
    ['011500120', 'Rhode Island'],
    ['021313103', 'Vermont'],
];
var BankInfoInput = function (props) {
    var _a = useBankInfo(), bankInfoForm = _a.bankInfoForm, setBankInfoForm = _a.setBankInfoForm;
    var linkTokenPayload = useOpts().linkTokenPayload;
    var textRoutingNumberField = {
        fieldType: 'text',
        fieldSubtype: 'plaintext',
        key: 'routingNumber',
        label: 'Routing number',
        pattern: '[0-9]{9}',
        required: true,
    };
    var citizensRoutingNumberField = {
        fieldType: 'select_single',
        key: 'routingNumber',
        label: 'Routing number',
        options: CITIZENS_ROUTING_NOS.map(function (_a) {
            var n = _a[0], state = _a[1];
            return ({
                value: n,
                label: "".concat(n, " (").concat(state, ")"),
            });
        }),
        required: true,
    };
    return (React.createElement(TitleFrame, { title: "Confirm account Details", subtitle: "Enter the routing and account number where you want your paycheck to be deposited", "data-testid": "BankInfoInput" },
        React.createElement(TemplateForm, { onSubmit: function (v) {
                setBankInfoForm(v);
                props.onContinue();
            }, initialValues: bankInfoForm, submitButtonText: "Review", fieldConfigs: [
                checkHackyWorkspace('Citizens', linkTokenPayload === null || linkTokenPayload === void 0 ? void 0 : linkTokenPayload.workspaceName)
                    ? citizensRoutingNumberField
                    : textRoutingNumberField,
                {
                    fieldType: 'text',
                    fieldSubtype: 'plaintext',
                    key: 'accountNumber',
                    label: 'Account number',
                    minLength: 5,
                    maxLength: 17,
                    pattern: '[0-9]+',
                    required: true,
                },
                {
                    fieldType: 'toggleButtonGroup',
                    key: 'accountType',
                    label: '',
                    options: [
                        { value: 'checking', label: 'Checking' },
                        { value: 'savings', label: 'Savings' },
                    ],
                    required: true,
                },
            ] })));
};
export default BankInfoInput;
